<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row>
          <h2 class="purple bold">Estatísticas dos Professores</h2>
          <h3 v-if="count" class="tags_count">{{ count }}</h3>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-50">
      <b-col md="3">
        <SelectCycles v-model="cycle" :callback="callbackCycles" />
        <span class="clear-field" v-if="this.cycle != null" @click="clearCycles"
          >Limpar filtro</span
        >
      </b-col>
      <b-col md="4">
        <b-form-group label="Área do Conhecimento">
          <multiselect
            v-model="selectedSubject"
            :options="subjectsOptions"
            :multiple="true"
            placeholder="Selecione as áreas do conhecimento"
            label="designation"
            track-by="subject_id"
            selectLabel=""
            :disabled="!cycle"
            open-direction="bottom"
            @input="callbackSubjects"
          >
            <span slot="noResult">Nada encontrado</span>
          </multiselect>
        </b-form-group>
        <span
          class="clear-field"
          v-if="this.selectedSubject && this.selectedSubject.length > 0"
          @click="clearSubject"
          >Limpar filtro</span
        >
      </b-col>
      <b-col md="5">
        <b-form-group label="Buscar Professor">
          <b-input-group-prepend>
            <b-form-input
              type="search"
              placeholder="Digite aqui"
              v-model="searchTitle"
              v-on:keyup.enter="
                page = 1;
                getList();
              "
            ></b-form-input>
            <b-input-group-text
              class="clear-fields"
              v-if="
                searchTitle != '' ||
                cycle != null ||
                (selectedSubject && selectedSubject.length > 0)
              "
              v-b-tooltip.hover
              title="Limpar Pesquisa"
            >
              <b-icon icon="x" @click="clearFields" />
            </b-input-group-text>
          </b-input-group-prepend>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <CardTable
          :items="teachers"
          :fields="fields"
          :busy="!isRequestSend"
          class="list-top"
        >
          <template #cell(name)="{ item }">{{ item.User.name }}</template>

          <template #cell(subjects)="{ item }">{{ subjectsText(item) }}</template>

          <template #cell(cycle)="{ item }">
            <TagBadge
              v-for="c in teacherCycles(item)"
              v-bind:key="c.id"
              :label="c.name"
              variant="blue"
            />
          </template>

          <template #cell(notifications)="{ item }">
            <TeacherNotificationsCell :notifications="item.Notifications" />
          </template>

          <template #cell(evaluations)="{ item }">
            <TeacherEvaluationsCell :evaluations="item.lastEvaluationsDates" />
          </template>

          <template #cell(actions)="{ item }">
            <div class="acoes">
              <PopoverIcon :id="`status-info-${item.id}`" title="Detalhes" triggers="hover">
                <template #icon>
                  <ListIcon />
                </template>

                <div class="popover-body">
                  <div class="popover-row">
                    <span class="popover-label">Status</span>
                    <TeacherEvaluationStatusCell :status="currentMonthStatus(item)" />
                  </div>
                  <div class="popover-row">
                    <span class="popover-label">Última avaliação</span>
                    <span class="popover-value">{{ lastEvaluationDate(item) }}</span>
                  </div>
                  <div class="popover-row">
                    <span class="popover-label">Pareceres</span>
                    <span class="popover-value">{{ statementsCount(item) }}</span>
                    <span class="popover-sublabel"
                      >Último em {{ lastStatementDate(item) }}</span
                    >
                  </div>
                </div>
              </PopoverIcon>

              <router-link
                :to="{
                  name: 'coordenacao-professor-notificacoes',
                  params: { id: item.id, teacher: item },
                }"
                class="icon-btn"
                v-b-tooltip.hover
                title="Visualizar notificações"
              >
                <ViewIcon />
              </router-link>

              <router-link
                :to="{
                  name: 'coordenacao-professor-estatisticas',
                  params: { id: item.id, teacher: item },
                }"
                class="icon-btn"
                v-b-tooltip.hover
                title="Visualizar estatísticas"
              >
                <ChartIcon />
              </router-link>
            </div>
          </template>
        </CardTable>

        <b-row class="align-center" v-if="count > perPage && isRequestSend">
          <b-pagination
            v-model="page"
            :per-page="perPage"
            :total-rows="count"
            @change="changePage"
            aria-controls="teachersList"
            last-text
            first-text
          >
            <template #prev-text>
              <LeftArrowIcon class="left" />
            </template>
            <template #next-text>
              <LeftArrowIcon />
            </template>
          </b-pagination>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LeftArrowIcon from "@/components/svg/LeftArrowIcon.vue";
import ViewIcon from "@/components/svg/ViewIcon.vue";
import ChartIcon from "@/components/svg/ChartIcon.vue";
import ListIcon from "@/components/svg/ListIcon.vue";
import SelectCycles from "@/components/inputs/SelectCycles.vue";
import CardTable from "@/components/table/CardTable.vue";
import PopoverIcon from "@/components/table/PopoverIcon.vue";
import TagBadge from "@/components/table/TagBadge.vue";
import TeacherNotificationsCell from "@/components/table/TeacherNotificationsCell.vue";
import TeacherEvaluationsCell from "@/components/table/TeacherEvaluationsCell.vue";
import TeacherEvaluationStatusCell from "@/components/table/TeacherEvaluationStatusCell.vue";
import { FromIsoStringToBRDate } from "@/utils/fomatDate";
import httpRda from "../../../http-rda";

export default {
  name: "registros-professores",

  components: {
    LeftArrowIcon,
    ViewIcon,
    ChartIcon,
    ListIcon,
    SelectCycles,
    CardTable,
    PopoverIcon,
    TagBadge,
    TeacherNotificationsCell,
    TeacherEvaluationsCell,
    TeacherEvaluationStatusCell,
  },

  data() {
    return {
      teachers: [],

      isRequestSend: false,

      cycle: null,
      subject: null,
      searchTitle: "",

      page: 1,
      count: 0,
      perPage: 20,
      cycle_select: null,
      subjectsOptions: [],
      selectedSubject: [],
      fields: [
        { key: "name", label: "Nome", tdClass: "nome" },
        { key: "subjects", label: "Área do Conhecimento", tdClass: "area" },
        { key: "cycle", label: "Ciclo" },
        { key: "notifications", label: "Notificações" },
        { key: "evaluations", label: "Avaliações", thClass: "text-center" },
        { key: "actions", label: "Ações", thClass: "text-center" },
      ],
      breadcrumb: [
        {
          text: "Coordenação",
          href: "/coordenacao",
        },
        {
          text: "Estatísticas dos Professores",
          href: "/coordenacao/professores",
          active: true,
        },
      ],
    };
  },

  methods: {
    getRequestParams(searchTitle, page, perPage, subject, cycle) {
      let params = {};

      if (searchTitle) {
        params["search"] = searchTitle;
      }

      if (page) {
        params["page"] = page;
      }

      if (perPage) {
        params["limit"] = perPage;
      }

      if (subject) {
        params["subjects"] = Array.isArray(subject)
          ? subject.join(",")
          : subject;
      }

      if (cycle) {
        params["cycles"] = cycle;
      }

      return params;
    },

    async getList() {
      const params = this.getRequestParams(
        this.searchTitle,
        this.page,
        this.perPage,
        this.subject,
        this.cycle
      );
      params.active = 1;
      params.include = "notifications";

      const queryParams = {};
      if (this.searchTitle) queryParams.search = this.searchTitle;
      if (this.page && this.page !== 1) queryParams.page = this.page;
      if (this.cycle) queryParams.cycle = this.cycle;
      if (this.subject) {
        queryParams.subject = Array.isArray(this.subject)
          ? this.subject.join(",")
          : this.subject;
      }

      this.$router.replace({ query: queryParams }).catch(() => {});

      await httpRda
        .get("/teachers-opt", { params })
        .then((response) => {
          this.teachers = response.data.teachers;
          this.count = response.data.count;
          this.isRequestSend = true;
        })
        .catch((error) => {
          return error;
        });
    },

    teacherCycles(teacher) {
      if (!this.cycle) {
        return teacher.Cycles || []
      }

      return (teacher.Cycles || []).filter((cycle) => cycle.id === this.cycle)
    },

    subjectsText(teacher) {
      return [...new Set((teacher.Subjects || [])
        .map((subject) => subject.designation))]
        .join(", ");
    },

    currentMonthStatus(teacher) {
      return (
        (teacher.lastEvaluationsDates &&
          teacher.lastEvaluationsDates.currentMonth &&
          teacher.lastEvaluationsDates.currentMonth.status) ||
        null
      );
    },

    lastEvaluationDate(teacher) {
      const date =
        teacher.lastEvaluationsDates &&
        teacher.lastEvaluationsDates.currentMonth &&
        teacher.lastEvaluationsDates.currentMonth.last_evaluation_date;

      return date ? FromIsoStringToBRDate(date) : "—";
    },

    statementsCount(teacher) {
      return (teacher.statementsCount && teacher.statementsCount.count) || "—";
    },

    lastStatementDate(teacher) {
      const date =
        teacher.statementsCount && teacher.statementsCount.last_created_at;

      return date ? FromIsoStringToBRDate(date) : "—";
    },

    async getSubjects(cycleId) {
      if (!cycleId) {
        this.subjectsOptions = [];
        return;
      }

      try {
        const response = await httpRda.get("/subjects-select", {
          params: { cycleId },
        });

        if (response.data && response.data.subjects) {
          this.subjectsOptions = response.data.subjects.map((item) => ({
            subject_id: item.subject_id,
            designation: item.subject_designation,
          }));
        } else {
          this.subjectsOptions = [];
        }
      } catch (error) {
        this.subjectsOptions = [];
      }
    },

    async callbackCycles({ id }) {
      this.cycle = id !== -1 ? id : null;
      this.cycle_select = id;
      this.page = 1;
      this.subject = null;
      this.selectedSubject = [];
      this.subjectsOptions = [];

      if (this.cycle) {
        await this.getSubjects(this.cycle);
      }

      this.getList();
    },

    callbackSubjects(selected) {
      this.subject =
        selected && selected.length > 0
          ? selected.map((item) => item.subject_id)
          : null;
      this.page = 1;
      this.getList();
    },

    clearSubject() {
      this.subject = null;
      this.selectedSubject = [];
      this.page = 1;
      this.getList();
    },

    changePage(page) {
      this.page = page;
      this.getList();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    clearFields() {
      this.searchTitle = "";
      this.cycle = null;
      this.subject = null;
      this.selectedSubject = [];
      this.page = 1;
      this.getList();
    },

    clearCycles() {
      this.cycle = null;
      this.subject = null;
      this.selectedSubject = [];
      this.subjectsOptions = [];
      this.page = 1;
      this.getList();
    },
  },

  async created() {
    const query = this.$route.query;

    this.searchTitle = query.search || "";
    this.page = Number(query.page) || 1;
    this.cycle = query.cycle ? Number(query.cycle) : null;
    this.cycle_select = query.cycle ? Number(query.cycle) : null;

    if (query.subject) {
      const subjectIds = query.subject.includes(",")
        ? query.subject.split(",").map(Number)
        : [Number(query.subject)];
      this.subject = subjectIds;
    }

    if (this.cycle) {
      await this.getSubjects(this.cycle);

      if (this.subject && this.subjectsOptions.length > 0) {
        this.selectedSubject = this.subjectsOptions.filter((opt) =>
          this.subject.includes(opt.subject_id)
        );
      }
    }

    this.getList();
  },

  watch: {
    "$route.query": {
      handler(query) {
        this.searchTitle = query.search || "";
        this.page = Number(query.page) || 1;
        this.cycle = query.cycle ? Number(query.cycle) : null;
        this.cycle_select = query.cycle ? Number(query.cycle) : null;

        if (query.subject) {
          const subjectIds = query.subject.includes(",")
            ? query.subject.split(",").map(Number)
            : [Number(query.subject)];
          this.subject = subjectIds;

          if (this.subjectsOptions.length > 0) {
            this.selectedSubject = this.subjectsOptions.filter((opt) =>
              this.subject.includes(opt.subject_id)
            );
          }
        } else {
          this.subject = null;
          this.selectedSubject = [];
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.tags_count {
  background-color: #68c5b7;
  border-radius: 3px;
  color: #fff;
  margin-left: 10px;
  padding: 3px 10px;
  height: max-content;
}
.list-top {
  margin-top: 30px;
  margin-bottom: 30px;
}

.popover-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 300px;
}

.popover-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 10px;
  border-bottom: 1px solid $grey6;

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
}

.popover-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: $grey4;
}

.popover-value {
  font-size: 14px;
  font-weight: 700;
  color: $grey1;
}

.popover-sublabel {
  font-size: 11px;
  color: $grey5;
}

.acoes {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
}

.icon-btn {
  color: $orange;
  padding: 4px;
  line-height: 1;
}

::v-deep .nome {
  color: $grey1;
  min-width: 200px;
}

::v-deep .area {
  color: $grey4;
  max-width: 260px;
  line-height: 1.4;
  font-size: 14px;
}

::v-deep .multiselect--disabled {
  opacity: 0.6;
  cursor: not-allowed;

  .multiselect__select {
    background-color: #ededed;
  }

  .multiselect__tags {
    background-color: #ededed;
    pointer-events: none;
  }
}
</style>
